import { addSpaceBeforeCapitalLetter } from "src/app/shared/utils/addSpaceBeforeCapitalLetter";

export enum OrderStatus{
    Processing = 1,
    OutForDelivery = 2,
    Delivered = 3,
    Pending = 4,
    Canceled = 5,
    Success = 6,
}

export const OrderStatusData = Object.entries(OrderStatus).filter(e => !isNaN(e[0] as any)).map(e => ({
    value: +e[0],
    name: addSpaceBeforeCapitalLetter(e[1].toString())
  }));
// export function getOrderStatusLabel(status: string): string {
//     const statusItem = OrderStatusEnum.find(item => item.value === status);
//     return statusItem ? statusItem.label : "Unknown Status";
//   }